import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { progressInfo } from './../lineManage/request';
export default {
  data() {
    return {
      dialogVisible: false,
      current: 0,
      isFirst: true,
      list: [],
      status: ""
    };
  },
  methods: {
    init(val) {
      progressInfo({
        reviewNodeId: val.reviewNodeId
      }).then(res => {
        res.map((item, index) => {
          item.title = item.userType == 1 ? item.userTypeName + ':' + item.userName : item.status != 1 ? item.userTypeName + ':' + item.userName + '(' + item.statusName + ')' : item.userTypeName + ':' + item.userName;
          if (item.status == 1 && this.isFirst) {
            this.isFirst = false;
            this.current = index;
            this.status = 'process';
          } else if (item.status == 4 && this.isFirst) {
            this.current = index;
            this.isFirst = false;
            this.status = 'error';
          } else if (item.status == 2 && this.isFirst) {
            this.current = index;
            this.isFirst = false;
            this.status = 'wait';
          }
        });
        if (this.isFirst) {
          this.current = res.length;
          this.status = 'finish';
        }
        this.list = res;
        this.dialogVisible = true;
      });
    }
  }
};